module.exports = __webpack_public_path__ + "static/media/gur_img.03442831.png";